import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PAYMENT_FLOW_SCHEMA_QUERY_KEY} from "../queryKeys";
import {PaymentFlowSchema} from "./types";

const getPaymentFlowsSchema = async (): Promise<PaymentFlowSchema> => {
  const response = await axiosReachInstance.get<PaymentFlowSchema, AxiosResponse<PaymentFlowSchema>>(
    "/payment_flows/schema"
  );
  return response.data;
};

export const useGetPaymentFlowsSchema = (
  options?: BaseQueryOptions<PaymentFlowSchema, void>
): BaseUseQueryResult<PaymentFlowSchema> => {
  return useBaseQuery<PaymentFlowSchema, void>(
    [PAYMENT_FLOW_SCHEMA_QUERY_KEY],
    getPaymentFlowsSchema,
    undefined,
    options
  );
};
